// extracted by mini-css-extract-plugin
module.exports = {"pane":"SlidingPane_pane__ob0aq","back":"SlidingPane_back__hnPfO","arrow":"SlidingPane_arrow__Swn1G"};